/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Modal, ModalProps, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { IconButtonProps } from '~components/_common/IconButton/IconButton';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { useStyles } from '~src/hooks/useStyles';

export interface SimpleDeleteModalProps extends Partial<ModalProps> {
  isLoading?: boolean;
  onReject?: () => Promise<unknown>;
  onCancel?: () => void;
  modalTitle: string;
  customText?: string;
  modalIcon?: IconButtonProps['icon'];
}
export const SimpleDeleteModal: React.FC<SimpleDeleteModalProps> = ({
  isLoading,
  onOk,
  onCancel,
  modalTitle,
  modalIcon,
  customText,
  ...modalProps
}) => {
  const intl = useIntl();
  // const styles = useStyles(styleFn);

  return (
    <Modal
      title={<ModalTitle text={modalTitle} icon={modalIcon} />}
      width={420}
      centered
      okButtonProps={{ danger: true, loading: isLoading }}
      onOk={onOk}
      onCancel={onCancel}
      bodyStyle={{ padding: 0 }}
      {...modalProps}>
      <div style={{ padding: '25px' }}>{customText}</div>
    </Modal>
  );
};
